import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ParComplaintsDocumentsService } from '../../services/par-complaints-documents/par-complaints-documents.service';
import { environment } from '../../../environments/environment';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
declare let ga: any;

@Component({
  selector: 'app-par-complaints-document-delete-dialog',
  templateUrl: './par-complaints-document-delete-dialog.component.html',
  styleUrls: ['./par-complaints-document-delete-dialog.component.css']
})
export class ParComplaintsDocumentDeleteDialogComponent implements OnInit {
  id: any;
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  firstName;
  lastName;
  loginId;

  constructor(private parComplaintsDocumentsService: ParComplaintsDocumentsService,
    public dialogRef: MatDialogRef<ParComplaintsDocumentDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public complaintDocumentData: any,
    private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteComplaintsDocument() {
    this.id = this.complaintDocumentData._id;
    this.parComplaintsDocumentsService.deleteComplaintsDocuments(this.id, this.complaintDocumentData.ComplaintId).subscribe(res => {
      ga('CompliantsTracker.send', 'event',this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[9],this.loginId, 1);
      this.parComplaintsDocumentsService.load.next('success');
      this.onNoClick();
    }, error => {
      this.DocTypeErrMsg = "Delete par complaints document" + error;
      this.DocTypeErr = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/par-complaints-document-delete-dialog/par-complaints-document-delete-dialog.component.ts